<template>
    <div class="about" style="background-color: #FFFFFF;">
        <van-sticky>
            <van-nav-bar title="隐私政策" :border="false" left-arrow @click-left="goBack">

            </van-nav-bar>
        </van-sticky>

        <div style="font-size: 12px;color:#515a6e;padding: 10px 15px; background-color: #FFFFFF;">
            <div class="wcc-header-1"> 本隐私政策发布并生效于 2021年9月28日</div>
            <div class="wcc-header-1">随申查隐私政策</div>

            <div class="wcc-content">
                “随申查”是由上海新兴信息通信技术应用研究院（以下简称“研究院”）为您提供移动网络和WIFI网络测速和网络检测诊断服务的应用。我们非常重视您的个人信息和隐私保护，我们将会按照法律要求和业界成熟的安全标准，为您的个人信息提供相应的安全保护措施。本隐私政策适用于“随申查”基于本客户端所提供的服务，请您在使用本客户端服务前，仔细阅读并了解本隐私政策。
            </div>

            <div class="wcc-content">• 我们为您提供移动网络和WIFI网络的网络测速和网络检测诊断服务。</div>
            <div class="wcc-content">• 当您使用我们的网络测速或网络检测与检测诊断服务时，我们会收集和处理您的位置数据用于网络测速和检测诊断（包括网络信息、基站ID、上传下载速率等网络指标）。
            </div>
            <div class="wcc-content">• 我们会将网络测速或检测诊断结果经过统计处理后共享给电信运营商，用于通信网络质量的改善和手机功能的优化。"</div>


            <div class="wcc-header-2">1. 我们如何收集和使用您的个人信息
            </div>
            <div class="wcc-content">网络测速服务
            </div>
            <div class="wcc-content">
                您可以使用“随申查”的测速功能来测试运营商移动网络、WIFI宽带网络的上传、下载速率以及网络的时延，抖动等性能指标，并生成测速历史记录，为此我们需要收集您的位置信息、无线基站小区ID、网络信息、测速速率。
            </div>

            <div class="wcc-content">网络检测诊断服务
            </div>
            <div class="wcc-content">
                您可以使用“随申查”的检测诊断功能来分析网络状态、数据状态和手机状态来诊断当前您的上网故障问题，并给出初步的处理建议。为此我们将收集您的手机信息和网络诊断信息，包含终端型号、终端系统、接入无线基站小区ID、
                网络信息和诊断结果等信息，用以在应用内向用户呈现。
            </div>
            <div class="wcc-content">
                研究院收集您的上述个人数据进行统计分析，同时用于以下目的：
            </div>
            <div class="wcc-content">• 运营商网络质量评测</div>
            <div class="wcc-content">• 内网网络质量评测</div>
            <div class="wcc-content">• 指导运营商网络质量的优化</div>
            <div class="wcc-content">• 手机功能的优化</div>

            <div class="wcc-content">
                地图服务
            </div>
            <div class="wcc-content">
                在诊断服务中，我们集成了高德地图SDK来提供地图服务，使用户能够直观的定位故障诊断的地点，并可在地图上调整自己的实际位置，以便能够更加准确定位你附近的无线基站信息。高德地图SDK可能会收集您的设备信息、位置信息，具体请您查阅相关的隐私政策。
            </div>


            <div class="wcc-content">
                APP接入第三方SDK
            </div>
            <div class="wcc-content">
                高德地图SDK
            </div>


            <div class="wcc-content">获取权限：</div>
            <div class="wcc-content">个人常用设备信息、</div>
            <div class="wcc-content">位置信息、</div>
            <div class="wcc-content">网络信息</div>
            <div class="wcc-content">地理位置信息
            </div>

            <div class="wcc-content">
                使用目的：
            </div>
            <div class="wcc-content"> 使用户在应用内能够直观的查看测试的地点信息。在测速时，按照地点就近调用测速节点服务器，以保证测速的结果准确。</div>
            <div class="wcc-content"> 使用方式：调用系统相关接口自动采集</div>
            <div class="wcc-content"> 高德隐私协议：</div>
            <div class="wcc-content"><a
                    href="https://lbs.amap.com/pages/privacy/">https://lbs.amap.com/pages/privacy/</a>
            </div>


            <div class="wcc-content">
                极光认证SDK
            </div>

            <div class="wcc-content">获取权限：</div>
            <div class="wcc-content">个人常用设备信息、</div>
            <div class="wcc-content">位置信息、</div>
            <div class="wcc-content"> 网络信息、</div>
            <div class="wcc-content">手机号码</div>
            <div class="wcc-content"> 使用目的：</div>
            <div class="wcc-content">提高用户体验，取代用户输入手机号码接收短信验证码的方式，帮助用户实现一键登录。</div>
            <div class="wcc-content">使用方式：调用系统相关接口自动采集</div>
            <div class="wcc-content"> 极光隐私协议：</div>
            <div class="wcc-content"><a href="https://www.jiguang.cn/license/privacy">https://www.jiguang.cn/license/privacy</a>
            </div>
            <div class="wcc-header-2">2.设备权限调用
            </div>

            <div class="wcc-content">
                存储权限：为了存储必要的应用配置文件以及您所选择下载的内容，或读取您需要上传、同步的内容，需要调用您的存储权限。在 iOS 设备上此权限名为“照片权限”。
            </div>

            <div class="wcc-content">
                位置权限：测速和诊断服务需要获取您的位置信息，以帮助您显示当前所在地区，来自动寻找最优的测速服务器和定位您的网络故障基站信息。
            </div>

            <div class="wcc-content">
                您可以随时访问系统“设置”来管理您的系统权限。
            </div>


            <div class="wcc-header-2">3. 对未成年人的保护
            </div>

            <div class="wcc-content">
                本应用仅供年满18周岁，或达到您所在地区的法定成年年龄的个人使用。如果您未满18周岁，或未达到您所在地区的法定成年年龄，则需要您的法定监护人同意您使用本应用并同意相关应用的服务条款。父母和法定监护人也应采取适当的预防措施来保护未成年人，包括监督其对本应用的使用。

            </div>

            <div class="wcc-content">
                如果您未满18周岁，或未达到您所在地区的法定成年年龄，对于经您父母或法定监护人同意而收集您个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息，如果我们发现我们在未事先获得可证实的父母或法定监护人同意的情况下收集了您的个人信息，则会设法尽快删除相关数据。如果您未满18周岁，或未达到您所在地区的法定成年年龄，对于经您父母或法定监护人同意而收集您个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息，如果我们发现我们在未事先获得可证实的父母或法定监护人同意的情况下收集了您的个人信息，则会设法尽快删除相关数据。

            </div>

            <div class="wcc-header-2">4. 与第三方共享
            </div>

            <div class="wcc-content">
                我们不会与第三方分享您的任何个人信息。我们会将测速或网络信息统计结果共享给电信运营商，用于通信网络质量的改善和手机功能的优化。
            </div>

            <div class="wcc-header-2">5. 管理您的数据
            </div>

            <div class="wcc-content">
                我们为您设置了便捷方式来管理您的数据。您可以前往系统“设置”关闭“一键测速”的“位置信息”、“存储”、“电话”权限，视不同操作系统版本路径有所不同。
            </div>

            <div class="wcc-content">
                如您对您的数据主体权利有进一步要求或存在任何疑问、意见或建议，可通过本声明中“如何联系我们”章节中所述方式与我们取得联系，并行使您的相关权利。如您对您的数据主体权利有进一步要求或存在任何疑问、意见或建议，可通过本声明中“如何联系我们”章节中所述方式与我们取得联系，并行使您的相关权利。
            </div>

            <div class="wcc-header-2">
                6. 账号注销
            </div>
            <div class="wcc-content">
                账号注销操作是不可恢复的操作。同时，账号注销后，您将无法再登录相应账号使用相关服务，除随申查按照相关法律规定应该保留的相关信息、权益或其他数据外，在您注销账号项下存储、使用等的全部信息、数据等将会被永久删除，请您谨慎进行账号注销操作。此外，账号注销并不代表您在该账号注销前的所有账号行为和相关责任得到豁免或减损。
            </div>
            <div class="wcc-content">a、账号注销的流程</div>
            <div class="wcc-content">1.如果您需要注销账号，需同时满足以下条件：</div>
            <div class="wcc-content">1)账号最近1个月内无异常登录、密码修改、密码手机修改等其他影响账户安全的情形；</div>
            <div class="wcc-content">2)账号内无未完成的订单、服务等；</div>
            <div class="wcc-content">3)账号没有涉及任何的投诉举报或被投诉举报；</div>
            <div class="wcc-content">4)账号中无尚未使用的权益，如果您还有尚未使用的权益，注销申请将视为您主动放弃相应权益；</div>
            <div class="wcc-content">5)不存在任何拖欠或者未缴纳的款项；</div>
            <div class="wcc-content">6)您在随申查账号下的所有您有权的数据、信息等均已迁出及妥善备份，或您完全放弃保留、找回该等数据的权利；</div>
            <div class="wcc-content">7)账号注销并未涉及任何已发生的投诉、纠纷、诉讼，主管部门的调查等，以及不存在上述涉诉、被调整的现实性风险；</div>
            <div class="wcc-content">8)账号不存在其他依照法律法规的要求应当履行而尚未履行的义务等情形；</div>
            <div class="wcc-content">
                2.随申查在核查过程中，如果发现您账号不能同时满足上述条件的，您的账号注销申请将被驳回。如果您希望继续注销，需根据驳回原因处理完成相关事项后，重新发起账号注销申请。
            </div>
            <div class="wcc-content">b、账号注销的后果</div>
            <div class="wcc-content">您知悉并同意，账号完成注销流程后将产生包括但不限于以下后果：</div>
            <div class="wcc-content">1)您将无法依赖于该账号进行任何权限操作；</div>
            <div class="wcc-content">2)您原先拥有的账号将被收回，您无权再使用原有的账号。</div>
            <div class="wcc-content">3)您将无法找回该账号下您曾经存储、使用等的全部信息、数据等，研究院按照相关法律规定应该保留的相关信息或数据除外。</div>
            <div class="wcc-content">4)其他可能对您的权益造成损害或给您造成损失的后果。</div>
            <div class="wcc-content">c、账号注销的方法</div>
            <div class="wcc-content">在APP内点击“我的”点击“账号注销”同意“注销须知”后，点击“立刻注销”即可。</div>

            <div class="wcc-header-2">
                7. 数据存储地点及期限
            </div>

            <div class="wcc-content">
                本应用收集的个人信息将会传输并保存至中华人民共和国境内的服务器。
            </div>

            <div class="wcc-content">
                我们保留以下目的相关的历史性数据：进行分析和准备产品增强，准备市场报告，并将测速结果共享给电信运营商，用于通信网络质量的改善和手机功能的优化。

            </div>

            <div class="wcc-content">
                此外，当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。

            </div>


            <div class="wcc-header-2">8. 如何联系我们
            </div>

            <div class="wcc-content">
                我们设立了个人信息保护专职部门（或个人信息保护专员），您可以通过访问隐私问题与其取得联系，我们会尽快回复。
            </div>

            <div class="wcc-content">
                如果您对我们的回复不满意，特别是当我们的个人信息处理行为损害了您的合法权益时，您还可以通过向有管辖权的人民法院提起诉讼、向行业自律协会或政府相关管理机构投诉等外部途径进行解决。您也可以向我们了解可能适用的相关投诉途径的信息。
            </div>

            <div class="wcc-content">
                研究院将始终遵照我们的隐私政策来收集和使用您的信息。
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {}
        },
        methods: {
            goBack: function () {
                if (window.JSInterface) {
                    window.JSInterface.callMethod('close', null)
                }
                else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.JSInterface) {
                    window.webkit.messageHandlers.JSInterface.postMessage("{\"method\":\"close\"}");
                }
            },
        }
    }
</script>

<style scoped>
    .wcc-header-1 {
        text-align: center;
        font-size: 1.2em;
        line-height: 2em;
        font-weight: bold;
        margin-bottom: 10px;
    }

    .wcc-header-2 {
        font-size: 1.1em;
        line-height: 2em;
        font-weight: bold;
    }

    .wcc-content {
        text-indent: 2em;
        margin-bottom: 10px;
    }

    .van-nav-bar {
        background-color: #FFFFFF;
    }
</style>
